module.exports = __webpack_public_path__ + "img/right_white.e41bb48b.svg";